import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import gallery18 from "../../../assets/technical/img_5.jpg";

const Details = () => {
  return (
    <Box margin={{ xs: "25% 0% 10% 0%", sm: "5% 0% 2% 0%" }}>
      <Typography
        variant="h3"
        color="#00AEEF"
        fontWeight={900}
        paddingBottom={"3%"}
        textAlign={"left"}
      >
        Technical Department
      </Typography>
      <Box
        width={"100%"}
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"flex-start"}
        flexWrap={"wrap"}
      >
        <Box
          width={{ xs: "100%", sm: "42%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
          paddingRight={{ xs: "0%", sm: "2%" }}
        >
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            lineHeight={"1.625em"}
          >
            The Technical Department of Aquatic Hub Afrique Network Limited
            designs, constructs, and fabricates fish gears and equipment needed
            across multiple value chains. The department has taken up projects
            of great magnitude across different parts of the country and
            delivered upon conclusion.
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={700}
            textAlign={"left"}
            paddingTop={"4%"}
            color={"#4f4f4f"}
            lineHeight={"1.625em"}
          >
            Equipment and Fish Gears fabricated are:
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"2%"}
            lineHeight={"1.625em"}
          >
            <Typography
              component={"span"}
              color="#00AEEF"
              fontWeight={500}
              variant={"h5"}
            >
              &#10066;{" "}
            </Typography>
            Modern Smoking Kilns (100 KG, 150 KG, and 250 KG Capacity)
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"1%"}
            lineHeight={"1.625em"}
          >
            <Typography
              component={"span"}
              color="#00AEEF"
              fontWeight={500}
              variant={"h5"}
            >
              &#10066;{" "}
            </Typography>
            Fish Cages (Big Cages 6X6X3 Metres and Small Cages 3X3X3 Metres)
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"1%"}
            lineHeight={"1.625em"}
          >
            <Typography
              component={"span"}
              color="#00AEEF"
              fontWeight={500}
              variant={"h5"}
            >
              &#10066;{" "}
            </Typography>
            Fibre Glass Tanks (Circular, Rectangular, and Hatching Troughs)
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"1%"}
            lineHeight={"1.625em"}
          >
            <Typography
              component={"span"}
              color="#00AEEF"
              fontWeight={500}
              variant={"h5"}
            >
              &#10066;{" "}
            </Typography>
            Aquariums
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"1%"}
            lineHeight={"1.625em"}
          >
            <Typography
              component={"span"}
              color="#00AEEF"
              fontWeight={500}
              variant={"h5"}
            >
              &#10066;{" "}
            </Typography>
            Collapsible Tanks, Wooden Vats, Concrete and Earthen Ponds
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"1%"}
            lineHeight={"1.625em"}
          >
            <Typography
              component={"span"}
              color="#00AEEF"
              fontWeight={500}
              variant={"h5"}
            >
              &#10066;{" "}
            </Typography>
            Boats and Small Floating Vessels (Fibre Glass and Steel)
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"2%"}
            lineHeight={"1.625em"}
          >
            All of these equipment and fish gears are also fabricated with the
            preferences of the client in mind.
          </Typography>
        </Box>
        <Box
          width={{ xs: "100%", sm: "55%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
          marginTop={{ xs: "10%", sm: "0%" }}
        >
          <Box
            component="img"
            height={{ xs: "27vh", sm: "400px" }}
            width={{ xs: "100%", sm: "100%" }}
            src={gallery18}
            alt={"technical-department-img"}
            sx={{
              objectFit: "cover",
              "&:hover": {
                opacity: 0.5,
              },
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Details;
